/* ==========================================================================
   TALAII — talaii-hero-intro.js
   Intro animada AL CARGAR (time-based, no scroll-driven). Las letras TALAII
   aparecen, se acomodan, se encogen y hacen cross-fade al hero.
   Robusta en Horizon (no depende del scroll del layout).
   Sin GSAP o reduced-motion → hero estático directo (fallback).
   ========================================================================== */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var heroIntro = document.getElementById('heroIntro');
  var introLogo = document.getElementById('introLogo');
  var heroLogo = document.getElementById('heroLogo');
  var hero = document.getElementById('hero');
  var nav = document.getElementById('nav');

  var enabled = document.documentElement.dataset.heroIntro === 'on';

  // La intro sale: en la PRIMERA visita y al RECARGAR (F5).
  // NO sale al navegar (ej. volver al home desde otra página).
  var SEEN_KEY = 'talaii_intro_seen';
  var alreadySeen = false;
  try { alreadySeen = sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) {}

  // ¿Esta carga fue una recarga? → mostrar la intro aunque ya se haya visto
  var isReload = false;
  try {
    var navEntries = performance.getEntriesByType('navigation');
    if (navEntries.length) {
      isReload = navEntries[0].type === 'reload';
    } else if (performance.navigation) {
      isReload = performance.navigation.type === 1; // fallback navegadores viejos
    }
  } catch (e) {}
  if (isReload) alreadySeen = false;

  // Bloquea/desbloquea el scroll de la página durante la intro
  function lockScroll() { document.documentElement.classList.add('talaii-intro-lock'); }
  function unlockScroll() { document.documentElement.classList.remove('talaii-intro-lock'); }

  // Sin intro / ya vista / sin elementos → hero estático, logo visible, scroll libre
  if (!enabled || alreadySeen || !hero || !heroIntro || !introLogo || !heroLogo) {
    if (heroIntro) heroIntro.classList.add('is-done');
    if (heroLogo) heroLogo.style.opacity = '1';
    unlockScroll();
    return;
  }

  function markSeen() { try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {} }

  function staticFallback() {
    heroIntro.classList.add('is-done');
    document.documentElement.removeAttribute('data-hero-intro-running');
    heroLogo.style.opacity = '1';
    if (nav) nav.classList.remove('nav--intro-hidden');
    unlockScroll();
    markSeen();
  }

  // --- Modo knockout: el SVG usa coordenadas de pantalla. Calculamos viewBox y
  // el transform de las letras con el tamaño real de la ventana (geometría exacta).
  var knockSvg = document.getElementById('knockSvg');
  var isKnockout = !!knockSvg;
  var LETTERS_W = 551, LETTERS_H = 92, LETTERS_RATIO = 0.6; // 60% del ancho

  function layoutKnockout() {
    if (!knockSvg) return null;
    var w = window.innerWidth, h = window.innerHeight;
    knockSvg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    var mr = document.getElementById('knockMaskRect');
    var vr = document.getElementById('knockVeilRect');
    if (mr) { mr.setAttribute('width', w); mr.setAttribute('height', h); }
    if (vr) { vr.setAttribute('width', w); vr.setAttribute('height', h); }
    var targetW = w * LETTERS_RATIO;
    var scale = targetW / LETTERS_W;
    var x = (w - targetW) / 2;
    var y = (h - LETTERS_H * scale) / 2;
    return { x: x, y: y, scale: scale };
  }

  function boot() {
    var gsapReady = !prefersReduced && typeof gsap !== 'undefined';
    if (!gsapReady) { staticFallback(); return; }

    document.documentElement.setAttribute('data-hero-intro-running', '1'); // muestra el overlay
    lockScroll();                                    // no scroll hasta que termine
    if (nav) nav.classList.add('nav--intro-hidden');   // texto azul sobre fondo arena
    gsap.set(heroLogo, { opacity: 0 });
    var cta = hero.querySelector('.hero__cta');
    if (cta) gsap.set(cta, { opacity: 0, y: 12 });

    var heroMedia = hero.querySelector('.hero__media img, .hero__media video');
    if (heroMedia) gsap.set(heroMedia, { scale: 1.12 });
    var letters = introLogo.querySelectorAll('.ltr');
    var lettersGroup = document.getElementById('knockoutLetters');
    var geo = isKnockout ? layoutKnockout() : null;

    if (isKnockout && geo && lettersGroup) {
      // Posición/escala base del grupo (centrado en pantalla)
      gsap.set(lettersGroup, { x: geo.x, y: geo.y, scale: geo.scale, transformOrigin: '0 0' });
      window.addEventListener('resize', function () {
        var g = layoutKnockout();
        if (g) gsap.set(lettersGroup, { x: g.x, y: g.y, scale: g.scale, transformOrigin: '0 0' });
      });
    }

    // Estado inicial de las letras: escalonadas hacia abajo, tenues.
    letters.forEach(function (ltr, i) {
      var n = letters.length - 1 || 1;
      if (isKnockout) {
        // Unidades del propio logo (alto = 92). Valores verificados con Playwright:
        // escalonado sutil (T casi en su sitio → última letra más abajo y tenue).
        gsap.set(ltr, {
          y: 14 + (i / n) * 30,
          opacity: 1 - (i / n) * 0.7,
          transformOrigin: '50% 100%'
        });
      } else {
        gsap.set(ltr, {
          yPercent: 40 + (i / n) * 120,
          opacity: 1 - (i / n) * 0.7,
          transformOrigin: '50% 100%'
        });
      }
    });

    var getTargetScale = function () {
      var introW = introLogo.getBoundingClientRect().width;
      var targetW = heroLogo.getBoundingClientRect().width || introW * 0.4;
      return introW ? targetW / introW : 0.4;
    };

    var tl = gsap.timeline({
      defaults: { ease: 'power2.out' },
      onComplete: function () {
        heroIntro.classList.add('is-done');
        document.documentElement.removeAttribute('data-hero-intro-running');
        if (nav) nav.classList.remove('nav--intro-hidden');
        unlockScroll();
        markSeen();
      }
    });
    // Toda la intro un 10% más rápida (mantiene el ritmo/proporciones internas)
    tl.timeScale(1.1);

    tl
      // 1. Las letras suben y se acomodan (stagger sutil)
      .to(letters, isKnockout
        ? { y: 0, opacity: 1, duration: 0.8, stagger: 0.06 }
        : { yPercent: 0, opacity: 1, duration: 0.8, stagger: 0.06 }, 0.2);

    // 2. El conjunto se encoge hacia el tamaño del logo del hero
    if (isKnockout && geo && lettersGroup) {
      var endScale = geo.scale * 0.45;
      var endW = LETTERS_W * endScale;
      var endH = LETTERS_H * endScale;
      tl.to(lettersGroup, {
        x: (window.innerWidth - endW) / 2,
        y: (window.innerHeight - endH) / 2,
        scale: endScale,
        ease: 'power2.inOut', duration: 1
      }, 1.2);
    } else {
      tl.to(introLogo, { scale: getTargetScale, ease: 'power2.inOut', duration: 1 }, 1.2);
    }

    tl
      // 3. Cross-fade: la imagen del hero hace zoom-out mientras la intro se desvanece
      .to(heroMedia || {}, { scale: 1, duration: 1.2, ease: 'power2.out' }, 1.4)
      .to(heroIntro, { opacity: 0, duration: 0.6, ease: 'power1.in' }, 1.9)
      .to(heroLogo, { opacity: 1, duration: 0.6, ease: 'power1.out' }, 2.1)
      .to(cta || {}, { opacity: 1, y: 0, duration: 0.5 }, 2.3);
  }

  // Seguridad: si algo falla, no dejar la intro tapando la página
  setTimeout(function () {
    if (heroIntro && !heroIntro.classList.contains('is-done')) staticFallback();
  }, 6000);

  if (typeof gsap !== 'undefined') {
    boot();
  } else {
    window.addEventListener('load', boot);
  }
})();
